import { withTheme } from "@emotion/react";
import CITFormGroup from "../../../../Form/CITFormGroup";
import { Typography, Box, Stack, FormControlLabel, Checkbox, Grid, FormHelperText, Divider } from "@mui/material";
import TextInput from "../../../../Form/TextInput";
import * as React from 'react';
import DateInput from "../../../../Form/DateInput";
import RadioButtonsGroup from "../../../../Form/RadioButtonsGroup";

const WorkExperience = (props) => {

    const theme = props.theme

    const faciltiies = ['Hospital', 'Hospice', 'Nursing Home', 'Rehab', 'Private Duty', 'Assisted Living', 'Other']
    const header = [{ skill: 'Skiils', year: '# of years' }, { skill: 'Skiils', year: '# of years' }, { skill: 'Skiils', year: '# of years' }]
    const skills1 = [['Burn', 'Detox/Drug Rehab', 'Telemetry', 'Psychiatry', 'Dialysis', 'PACU', 'Recovery Room', 'Neurology', 'Med/Surg', 'Other', 'Other'],
    ['ENT', 'L & D', 'MICU', 'Orthopedics', 'Stepdown', 'Geriatric', 'SICU', 'Operating Room', 'DetoOpen Heart', 'Other', 'Other'],
    ['Pediatrics', 'Rehab', 'Nursery', 'NICU', 'Mother/Baby',  'Oncology', 'Pedi ICU', 'CCU','Emergency Room', 'Other', 'Other']
    ]
    const answers = ['Yes', 'No']


    const Facilities = (props) => {

        return (
            <Box mt={props.mt ?? 0} width={'100%'}>
                <Stack direction={'column'}>
                    <Typography mb={'8px'} color={'#292727'} lineHeight={'normal'} fontWeight={700} fontStyle={'normal'} fontFamily={'Inter'} fontSize={'16px'}>{'Facilities'}</Typography>
                    <FormHelperText sx={{ ...theme.typography.inputTitle, color: '#292727', mb: '16px', mr: { xs: '75px', sm: '108px' } }} >{'Previous Types of Facilities Worked In: (check all that apply)'}</FormHelperText>
                </Stack>
                <Box mt={'0px !important'} width={'100%'}>
                    <Grid container rowSpacing={'16px'} columnSpacing={{ xs: '0px', sm: '48px' }} >
                        {faciltiies.map((facility) => (
                            <Grid key={facility} item xs={6} sm={3} md={3} >
                                <Stack spacing={{ xs: '16px', sm: '48px' }} width={'100%'} alignItems={'center'} direction={'row'}>
                                    <FormControlLabel control={<Checkbox />}
                                        label={<Typography color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'14px'} fontFamily={'inter'}>{facility}</Typography>} />
                                </Stack>
                            </Grid>
                        ))
                        }
                    </Grid>
                </Box>
            </Box>
        )
    }


    const WorkHistory = (props) => {

        return (
            <Box mt={props.mt ?? 0} width={'100%'}>
                <Stack direction={'column'}>
                    <Typography mb={'8px'} color={'#292727'} lineHeight={'normal'} fontWeight={700} fontStyle={'normal'} fontFamily={'Inter'} fontSize={'16px'}>{'Work Experience'}</Typography>
                    <FormHelperText sx={{ ...theme.typography.inputTitle, color: '#292727', mb: '16px', mr: { xs: '0px', sm: '108px' } }} >{'List all your work experience beginning with your most recent job. You will be asked to explain all gaps in employment.If your resume contains all this information, you may skip this part'}</FormHelperText>
                </Stack>
                <TextInput  textLable={"Employer name"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <CITFormGroup align="center" mt={'24px'} mx={'0px !important'} width={'100%'}>
                    <DateInput boxWidth={'100%'} inputWidth={'inherit'} dateLable={'Start date'} />
                     <Box mt={'24px !important'} width={'24px'}>
                       <Divider  sx={{ borderColor:'#292727'}}/>
                     </Box>
                     <DateInput boxWidth={'100%'} inputWidth={'inherit'} dateLable={'End date'} />
                </CITFormGroup>
                <FormControlLabel sx={{ mt:'8px' }} control={<Checkbox />} label={<Typography color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'14px'} fontFamily={'inter'}>{'I still work here'}</Typography>} />
                <TextInput mt='24px'  textLable={"Address"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <TextInput mt='24px'  textLable={"City, state, Zip"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <TextInput mt='24px'  textLable={"Job Title"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <RadioButtonsGroup  label={'May we contact this employer'} options={answers} />
                <TextInput mt='24px'  textLable={"If No state your reason below"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <CITFormGroup align="center" mt={'24px'} mx={'0px'} width={'100%'}>
                    <TextInput   textLable={"Name of supervisor"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                    <TextInput  textLable={"Telephone number"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                </CITFormGroup>
                <TextInput mt='24px'  textLable={"Reason for leaving"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <RadioButtonsGroup width='inherit'  label={'Are you legally authorized to work in the USA? '} options={answers} />
                <RadioButtonsGroup width='inherit'  label={'Have you ever been convicted of a felony? '} options={answers} />
                <RadioButtonsGroup  width='inherit' label={'Can you pass a pre-employment drug test? '} options={answers} />
                <TextInput mt='24px'  textLable={"How were you referred to Care In Touch Home Health Agency?"} placeholder={'Your Response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <CITFormGroup direction='column'  mt={'24px'} mx={'0px'} width={'100%'}>
                   <FormHelperText  sx={{ ...theme.typography.inputTitle, color: '#292727', mr: { xs: '0px', sm: '108px' }, mb:'-16px'}} >{'I understand that I must report all accidents to my immediate supervisor and to Care In Touch Home Health Agency – NO  MATTER HOW SLIGHT'}</FormHelperText>
                   <FormControlLabel sx={{ '& .MuiCheckbox-root':{pl:'0px'} }} control={<Checkbox />} 
                     label={
                     <Typography color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'14px'} fontFamily={'inter'}>{'Yes'}
                     </Typography>}
                    />
                </CITFormGroup>
                <CITFormGroup direction='column'  mt={'8px'} mx={'0px'} width={'100%'}>
                   <FormHelperText  sx={{ ...theme.typography.inputTitle, color: '#292727', mr: { xs: '0px', sm: '108px' }, mb:'-16px'}} >{'  I also understand that I must wear all required personal protection equipment (PPE). The penalty for not wearing PPE is disciplinary action, up to and including termination.'}</FormHelperText>
                   <FormControlLabel sx={{ '& .MuiCheckbox-root':{pl:'0px'} }} control={<Checkbox />} 
                     label={
                     <Typography color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'14px'} fontFamily={'inter'}>{'Yes'}
                     </Typography>}
                    />
                </CITFormGroup>

            </Box>
        )
    }


    const Experience = (props) => {

        return (
            <Box mt={props.mt ?? 0} width={'100%'}>
                <Stack direction={'column'}>
                    <Typography mb={'8px'} color={'#292727'} lineHeight={'normal'} fontWeight={700} fontStyle={'normal'} fontFamily={'Inter'} fontSize={'16px'}>{'Experience & Skills'}</Typography>
                    <FormHelperText sx={{ ...theme.typography.inputTitle, color: '#292727', mb: '16px', mr: { xs: '0px', sm: '108px' } }} >{'Work Experience/Skills: (Please list the number of years of experience in each area and are clinically competent to work:'}</FormHelperText>
                </Stack>
                <Box mt={'0px !important'} width={'100%'}>
                    <Grid container rowSpacing={'16px'} columnSpacing={{ xs: '0px', sm: '82px' }} >
                        {header.map((header,index) => (
                            <Grid key={index} item xs={12} sm={4} md={4} >
                                <SkillHeader skillHeading={header.skill} yearsHeading={header.year} />
                                {
                                    skills1[index].map((skill, i) => (
                                        <Box key={i}>
                                             <SkillItem  skill={skill}/>
                                        </Box>
                                       
                                    ))
                                }
                            </Grid>
                        ))
                        }
                    </Grid>
                </Box>
            </Box>
        )
    }

    const SkillHeader = (props) => {

        return (
            <Box width={'100%'}>
                <Stack justifyContent={{sm:'space-between'}} spacing={{ xs: '16px', sm: '117px' }} width={'100%'} alignItems={'center'} direction={'row'}>
                    <Typography flexBasis={{xs:'128px',sm:'0px'}} color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'12px'} fontFamily={'inter'}>{props.skillHeading}</Typography>
                    <Typography sx={{ml:{xs:'-24px !important',sm:''}}} color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'12px'} fontFamily={'inter'}>{props.yearsHeading}</Typography>
                </Stack>
            </Box>
        )
    }

    const SkillItem = (props) => {

        return (

            <Stack  justifyContent={'space-between'} spacing={{ xs: '16px', sm: '50px' }} width={'100%'} alignItems={'center'} direction={'row'}>
                <Typography width={{xs:'128px',sm:'271px'}} color='#292727' lineHeight={'normal'} fontStyle={'normal'} fontWeight={400} fontSize={'14px'} fontFamily={'inter'}>{props.skill}</Typography>
                <TextInput ml={'9px !important'} mt='24px' placeholder={'0'} boxWidth={'8ch'} inputWidth={'inherit'} />
            </Stack>
        )
    }





    return (

        <Box width={'inherit'}>
            <Stack mx={{ xs: '19px', sm: '60px', md: '85px' }} justifyContent={'space-around'} mt={'24px'} >
                <Typography width={{ sm: '668px', md: '998px' }} mb={'24px'} mt={'48px'} sx={{ ...theme.typography.heading, fontSize: { xs: '18px', sm: '20px', md: '29px' } }} gutterBottom>
                    {'WORK EXPERIENCE'}
                </Typography>
            </Stack>

            <CITFormGroup mt={'0px'} direction={'column'}>
                <Facilities />
                <Box width={'100%'}> <Divider /></Box>
                <Experience />
                <Box width={'100%'}> <Divider /></Box>
                <WorkHistory/>
            </CITFormGroup>

        </Box>



    )
}

export default withTheme(WorkExperience);